import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import { tokenReceived } from 'app/slices/actions'
import { authService } from 'app/services/auth.service'
import axiosApi from 'app/axiosApi'
import { clientChannel } from 'utils/constants'
import { FixMeLater } from 'types'


export const tokenListenerMiddleware = createListenerMiddleware()
const w = window as FixMeLater
const loginFulfilled = authService.endpoints.login.matchFulfilled
const checkMfaFulfilled = authService.endpoints.checkMfa.matchFulfilled

tokenListenerMiddleware.startListening({
  matcher: isAnyOf(tokenReceived, loginFulfilled, checkMfaFulfilled),
  effect: (action) => {
    let accessToken: string | undefined

    if (tokenReceived.match(action)) {
      accessToken = action.payload?.accessToken
    } else if (loginFulfilled(action)) {
      accessToken = (action as any).payload?.accessToken
    } else if (checkMfaFulfilled(action)) {
      accessToken = (action as any).payload?.accessToken
    }

    if (accessToken) {
      axiosApi.setHeader(accessToken)
    }
    if (w.api) {
      w.api.send('accessToken', { accessToken })
    }

    // LOGIN broadcast (login + checkMfa için)
    if (loginFulfilled(action) || checkMfaFulfilled(action)) {
      clientChannel.postMessage({ type: 'LOGIN', payload: (action as any).payload })
    }
  },
})

